import styled from 'styled-components';
import { DARK_GREY_COLOR, LINK_COLOR, WHITE_COLOR } from '../../config/colors';

const Wrapper = styled.div`
	height: 60vh;
	overflow: auto;
	h4 {
		font-weight: bold;
	}
	h4,
	p {
		line-height: 1;
	}

	.ant-form-item {
		padding: 22px 8px;
		border-bottom: 1px solid ${DARK_GREY_COLOR};
		&.checkBox {
			padding-left: 34px;
			position: relative;
			.ant-checkbox-wrapper {
				position: absolute;
				left: -25px;
				top: 0;
			}
		}
	}
	.ant-checkbox-wrapper {
		display: flex;
		align-items: top;
	}
	.ant-input {
		border-radius: 0;
		border: 1px solid ${DARK_GREY_COLOR};
		background-color: ${WHITE_COLOR};
	}
	.icon-img {
		width: 75px;
		height: 75px;
		object-fit: fill;
		cursor: pointer;
	}
	.file-container {
		border: 1px solid ${DARK_GREY_COLOR};
		display: block;
		padding: 0 8px;
		white-space: nowrap;
		img,
		i {
			width: 75px;
			height: 75px;
			object-fit: fill;
			cursor: pointer;
			margin-right: 12px;
			vertical-align: top;
			margin-top: 3px;
		}
		div {
			display: inline-block;
			padding: 12px;
			padding-bottom: 0;
			border-left: 1px solid ${DARK_GREY_COLOR};
			.anchor {
				color: ${LINK_COLOR};
				text-decoration: underline;
				cursor: pointer;
			}
		}
		.ant-form-item-control {
			line-height: 1;
		}
		input {
			opacity: 0;
			position: fixed;
			left: -999px;
		}
	}
	.drop-down {
		height: 45px;
		cursor: pointer;
		overflow: hidden;
		margin-bottom: 12px;
		position: relative;
		> h3 {
			line-height: 32px;
			padding-bottom: 12px;
			padding-left: 8px;
			font-size: 16px;
			color: #00f;
			border-bottom: 1px solid ${DARK_GREY_COLOR};
			font-weight: bold;
		}
		&::before {
			content: '';
			display: block;
			border-left: 15px solid #00f;
			border-right: 15px solid transparent;
			border-top: 10px solid transparent;
			border-bottom: 10px solid transparent;
			position: absolute;
			right: -20px;
			top: 15px;
			transform: translate(-50%, -50%);
		}
		&.active {
			height: auto;
			&::before {
				border-left: 10px solid transparent;
				border-right: 10px solid transparent;
				border-top: 15px solid #00f;
				border-bottom: 15px solid transparent;
				right: 0;
				top: 23px;
			}
		}
	}
`;

export default Wrapper;
